var map = {
	"./10C.svg": 31,
	"./10D.svg": 32,
	"./10H.svg": 33,
	"./10S.svg": 34,
	"./2C.svg": 35,
	"./2D.svg": 36,
	"./2H.svg": 37,
	"./2S.svg": 38,
	"./3C.svg": 39,
	"./3D.svg": 40,
	"./3H.svg": 41,
	"./3S.svg": 42,
	"./4C.svg": 43,
	"./4D.svg": 44,
	"./4H.svg": 45,
	"./4S.svg": 46,
	"./5C.svg": 47,
	"./5D.svg": 48,
	"./5H.svg": 49,
	"./5S.svg": 50,
	"./6C.svg": 51,
	"./6D.svg": 52,
	"./6H.svg": 53,
	"./6S.svg": 54,
	"./7C.svg": 55,
	"./7D.svg": 56,
	"./7H.svg": 57,
	"./7S.svg": 58,
	"./8C.svg": 59,
	"./8D.svg": 60,
	"./8H.svg": 61,
	"./8S.svg": 62,
	"./9C.svg": 63,
	"./9D.svg": 64,
	"./9H.svg": 65,
	"./9S.svg": 66,
	"./AC.svg": 67,
	"./AD.svg": 68,
	"./AH.svg": 69,
	"./AS.svg": 70,
	"./JC.svg": 71,
	"./JD.svg": 72,
	"./JH.svg": 73,
	"./JS.svg": 74,
	"./KC.svg": 75,
	"./KD.svg": 76,
	"./KH.svg": 77,
	"./KS.svg": 78,
	"./QC.svg": 79,
	"./QD.svg": 80,
	"./QH.svg": 81,
	"./QS.svg": 82
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30;